import createQueryStore from './createQueryStore';

const store = createQueryStore('subscriptionProduct');

export default store.reducer;
export const actions = store.actions;
export const useProductStore = store.useStore;
